import script from "./mailImporter.vue?vue&type=script&setup=true&lang=ts"
export * from "./mailImporter.vue?vue&type=script&setup=true&lang=ts"

import "./mailImporter.vue?vue&type=style&index=0&id=214ec32e&lang=css"

const __exports__ = script;

export default __exports__